/**
 * Created by Ning Jiang on 4/19/2016.
 */


import { IMysteryData, IPunkServerData, IPunkInitData, IPunkGameData, IPunkBetWinData } from "./data/PunkServerData";
import { ISymbolValues, IBetWinData } from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import { ServerDataParser } from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
export class PunkServerDataParser extends ServerDataParser {

    public parseMode(rawData:IPunkServerData):string { return rawData.mode; }

    public parseNextMode(rawData:IPunkServerData):string { return rawData.nextMode; }

    public parseReels(rawData:IPunkServerData):string[][] { return rawData.reels; }

    public parseOverlayStickySymbols(input:boolean[][]):boolean[] {
        let result:boolean[] = [];
        input.forEach((reel:boolean[], reelId:number) => {
            if(reelId < 2) {
                result = result.concat(reel.slice(1))
            } else {
                result = result.concat(reel);
            }
        });
        return result;
    }

    public parseNextReelSetName(rawData:IPunkServerData):string { return rawData.reelsNextSpin; }

    public parseTotalWin(rawData:IPunkServerData):number {
        return parseFloat(rawData.accumulatedRoundWin);
    }

    public parseCurrentMultiplier(rawData:IPunkServerData):number {
        return rawData.currentMultiplier != null ? rawData.currentMultiplier : 1;
    }

    public parseOverlayWilds(rawData:IPunkServerData):boolean[][] | undefined {
        return rawData.overlayWilds;
    }

    public parseFreespinsLeft(rawData:IPunkServerData):number {
        return rawData.freespinsLeft != null ? rawData.freespinsLeft : 0;
    }

    public parseFreespinTriggeredThisSpin(rawData:IPunkServerData):boolean {
        return rawData.freespinTriggeredThisSpin != null ? rawData.freespinTriggeredThisSpin : false;
    }

    public parseAddedNumberOfFreespinsThisSpin(rawData:IPunkServerData):number {
        return rawData.addedNumberOfFreespinsThisSpin != null ? rawData.addedNumberOfFreespinsThisSpin : 0;
    }

    public parseStickyPositions(rawData:IPunkServerData):string[] {
        return rawData.stickyPositions != null ? rawData.stickyPositions : [];
    }

    public parseScatterPositionsEnteringFreespin(rawData:IPunkInitData | IPunkGameData):number[] | undefined {
        return rawData.scatterPositionsEnteringFreespin;
    }

    // Init Data:
    public parseBetLines(rawData:IPunkInitData):number[][] {
        return rawData.betLines;
    }

    public parsemysterySymbolRevealed(rawData:IPunkInitData):string {
        return rawData.mysterySymbolRevealed!;
    }

    public parseSymbolValues(rawData:IPunkInitData):ISymbolValues {
        return rawData.symbolValues;
    }

    public parseIsRestoreState(rawData:IPunkInitData):boolean {
        return !!rawData.isRestoreState;
    }

    public parseBetWins(rawData:IPunkGameData):IPunkBetWinData[]{
        return rawData.betWins!;
    }

    public parseSingleWin(rawData:IPunkGameData):number {
        return parseFloat(rawData.totalSpinWinnings);
    }

    public parsePlayedBetValue(rawData:IPunkGameData):number {
        return parseFloat(rawData.playedBetValue);
    }

    public parseRespinTriggered(rawData:IPunkServerData):boolean{
        return !!rawData.respinTriggered;
    }

    public parseScatterPositions(rawData:IPunkGameData):number[] | undefined {
        return rawData.scatterPositions;
    }

    public parseReelsEnteringFreespin(rawData:IPunkGameData):string[][] | undefined {
        return undefined;
    }

    public parseBetLineWinsEnteringFreespin(rawData:IPunkGameData):IBetWinData[] | undefined {
        return rawData.betLineWinsEnteringFreespin;
    }

    public parseNumberOfFreespinsPlayed(rawData:IPunkGameData):number | undefined {
        return rawData.numberOfFreespinsPlayed;
    }
    public parseRGameAreaSize(rawData:IPunkInitData):number[]{
        return rawData.gameAreaSize;
     }

   public parseGameAreaSize(rawData:IPunkGameData):number[]{
       return rawData.gameAreaSize;
    }

   public parseSuperXways(rawData:IPunkGameData):number[]{
        return rawData.superXways;
    }   

    public parseMultiplierReel(rawData:IPunkGameData):number[]{
        return rawData.multiplierReel;
    }
    
    public parseMysteryData(rawData:IPunkGameData):IMysteryData{
        return {
            mysterySymbolAppeared: this.parseMysterySymbolAppeared(rawData),
            mysterySymbolPositions: this.parseMysterySymbolPositions(rawData),
            mysterySymbolRevealed: this.parseMysterySymbolRevealed(rawData),
            mysterySymbolOnReel: this.parseMysterySymbolOnReel(rawData),
            mysterySymbolSize: this.parseMysterySymbolSize(rawData)
        }
    }

    public parseFreespinTrain(rawData:IPunkGameData):string[]{
        return rawData.freespinTrain;
    }

    public parseMysterySymbolAppeared(rawData:IPunkGameData):boolean {
        return rawData.mysterySymbolAppeared;
    }

    public parseMysterySymbolPositions(rawData:IPunkGameData):number[] {
        return rawData.mysterySymbolPositions;
    }

    public parseMysterySymbolRevealed(rawData:IPunkGameData):string {
        return rawData.mysterySymbolRevealed;
    }

    public parseMysterySymbolOnReel(rawData:IPunkGameData):boolean[] {
        return rawData.mysterySymbolOnReel;
    }

    public parseMysterySymbolSize(rawData:IPunkGameData):number[] {
        return rawData.mysterySymbolSize;
    }

    public parseStickyWildPositions(rawData:IPunkGameData):string{
        return  rawData.stickyWildPositions;
    }
}